import React from 'react'
import DocumentTitle from 'react-document-title'

import {withStyles, Grid, Typography, Avatar} from 'material-ui'


const styles = theme => ({
    container: {
        zIndex: 1,
        position: 'relative',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-evenly',
        margin: "0 auto",
        background: "white",
    },
    content: {
        padding: 20,
        maxWidth: theme.layout.contentWidth,
        margin: "0 auto",
        marginBottom: 60,
        '& h1': theme.typography.display1,
        '& h2': theme.typography.headline,
        '& h3': theme.typography.subheading,
        '& p': theme.typography.caption,
    },
    titleMargins: {
        marginTop: "2em",
        marginBottom: "2em",
    },
    avatars: {
        width: "10em",
        height: "10em",
    },
    grow: {
        flex: 1
    },

})

export const Bios = withStyles(styles)(
    ({classes}) => (
    <div className={classes.container}>
        <div className={classes.content}>
            <Grid container spacing={24}>
                <Grid item xs={12} className={classes.titleMargins}>
                    <Typography component="h1" align="center" style={{color: "black"}}><strong>Meet our team</strong></Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <BioCard
                        title="Rick Copeland"
                        subtitle="CEO and Co-Founder"
                        text="Rick is passionate about helping family caregivers. As the son of caregiving parents, he recognized the toll that caregiving entailed and the need to find a way to help. He is a talented technologist and entrepreneur who has built successful software products and businesses."
                        image="/img/rick.jpg"/>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <BioCard
                        title="Louise Chang, M.D."
                        subtitle="CMO and Co-Founder"
                        text="Louise understands the challenges faced by patients, their families, and the providers who want to help. Her career in medicine and consumer health has focused on providing patients and families with health information and tools to empower their understanding and ability to take action."
                        image="/img/Louise.jpg"/>
                </Grid>
            </Grid>
        </div>
    </div>
    )
)


export const BioCard = withStyles(styles)(
    ({classes, image, title, subtitle, text}) => (
    <Grid container spacing={24} justify="center" alignItems="center">
        <Grid item sm={12} md={6}>
            <Avatar className={classes.avatars} alt={title} src={image} />
        </Grid>
        <Grid item sm={12} md={6}>
            <Typography component="h2" style={{color: "#0867C8"}}>{title}</Typography>
            <Typography component="h3">{subtitle}</Typography>
            <br/>
            <Typography component="p" style={{maxWidth: "20em"}}>{text}</Typography>
        </Grid>
    </Grid>
    )
)

export default Bios


// WEBPACK FOOTER //
// ./src/components/Bios.jsx